import { render, staticRenderFns } from "./DeviceList.vue?vue&type=template&id=2b241a50&scoped=true&"
import script from "./DeviceList.vue?vue&type=script&lang=js&"
export * from "./DeviceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b241a50",
  null
  
)

export default component.exports